import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "incomeCategoryModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content border-0 shadow expense-category-modal" }
const _hoisted_4 = { class: "modal-header border-0 pb-0 align-items-start" }
const _hoisted_5 = { class: "modal-badge mb-2" }
const _hoisted_6 = { class: "modal-title fw-bold text-title mb-1" }
const _hoisted_7 = { class: "text-muted mb-0" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = { class: "modal-body pt-4" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-md-5" }
const _hoisted_12 = { class: "field-header" }
const _hoisted_13 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_14 = { class: "field-caption" }
const _hoisted_15 = ["value", "placeholder"]
const _hoisted_16 = { class: "col-md-7" }
const _hoisted_17 = { class: "field-header" }
const _hoisted_18 = { class: "form-label fw-semibold text-title mb-0" }
const _hoisted_19 = { class: "field-caption" }
const _hoisted_20 = ["value", "placeholder"]
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "form-label fw-semibold text-title" }
const _hoisted_23 = ["value", "placeholder"]
const _hoisted_24 = { class: "modal-footer border-0 px-0 pb-0 pt-4 justify-content-between" }
const _hoisted_25 = {
  type: "button",
  class: "btn btn-light px-4 h-50",
  "data-bs-dismiss": "modal"
}
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-price-tag-3-line me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditMode ? _ctx.$t("income_category_page.update_category_badge") : _ctx.$t("income_category_page.new_category_badge")), 1)
            ]),
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.isEditMode ? _ctx.$t("income_category_page.edit_income_category") : _ctx.$t("income_category_page.create_income_category")), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("income_category_page.modal_description")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none mt-1",
            "data-bs-dismiss": "modal",
            "aria-label": _ctx.$t('common.close')
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('submit')), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("income_category_page.code")), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("income_category_page.short_unique_code")), 1)
                ]),
                _createElementVNode("input", {
                  value: _ctx.form.code,
                  type: "text",
                  class: "form-control modal-input",
                  placeholder: _ctx.$t('income_category_page.code_placeholder'),
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onTextInput('code', $event)))
                }, null, 40, _hoisted_15),
                (!_ctx.isEditMode)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-light generate-code-btn mt-3",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('generate-code')))
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-refresh-line me-1" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("income_category_page.generate_code")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("income_category_page.category_name")), 1),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("income_category_page.main_display_name")), 1)
                ]),
                _createElementVNode("input", {
                  value: _ctx.form.name,
                  type: "text",
                  class: "form-control modal-input",
                  placeholder: _ctx.$t('income_category_page.category_name_placeholder'),
                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTextInput('name', $event)))
                }, null, 40, _hoisted_20)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("income_category_page.description")), 1),
                _createElementVNode("textarea", {
                  value: _ctx.form.description,
                  rows: "5",
                  class: "form-control modal-input modal-textarea",
                  placeholder: _ctx.$t('income_category_page.description_placeholder'),
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTextInput('description', $event)))
                }, null, 40, _hoisted_23)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.$t("common.cancel")), 1),
              _createElementVNode("button", {
                type: "submit",
                class: "btn style-one px-4 h-50 modal-submit-btn",
                disabled: _ctx.loading
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-save-line me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.$t("income_category_page.saving") : _ctx.isEditMode ? _ctx.$t("income_category_page.update_category") : _ctx.$t("income_category_page.create_category")), 1)
              ], 8, _hoisted_26)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}